import DataBlocksBackground from './DataBlocksBackground';

const LOGO_SRC = `${process.env.PUBLIC_URL}/logo-vivo-surgery.png`;

function HomePage({ onOpenContact }) {
  return (
    <div className="vivo-shell">
      <DataBlocksBackground />
      <main className="vivo-main">
        <div className="vivo-hero-center">
          <img
            className="vivo-logo"
            src={LOGO_SRC}
            alt="VIVO SURGERY"
            width={640}
            height={400}
          />
          <p className="vivo-tagline">
            AI engine powering the next generation of surgical workflows.
          </p>
          <button type="button" className="vivo-cta" onClick={onOpenContact}>
            Contact
          </button>
        </div>
      </main>
    </div>
  );
}

export default HomePage;
